module.exports = __webpack_public_path__ + "d6fc5e8dafa01b521400f33a33e5a343.MP3";